export default "__VITE_ASSET__ipNR34EK__"